import {ref, watch} from 'vue';

export const isFirstTime = ref(localStorage.getItem('22m9-firstTime') !== 'false');

watch(isFirstTime, (value) => {
	if (!value) localStorage.setItem('22m9-firstTime', 'false');
});
